import { NgModule } from '@angular/core';

import { UserRoleFilterPipe } from './user-role-filter.pipe';

@NgModule({
  declarations: [UserRoleFilterPipe],
  exports: [UserRoleFilterPipe]
})
export class NguixDashboardUserRoleFilterPipeModule { }
